import { render, staticRenderFns } from "./SongAsset.vue?vue&type=template&id=19222463&scoped=true&"
import script from "./SongAsset.vue?vue&type=script&lang=js&"
export * from "./SongAsset.vue?vue&type=script&lang=js&"
import style0 from "./SongAsset.vue?vue&type=style&index=0&id=19222463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19222463",
  null
  
)

export default component.exports